<template>
  <div>
    <div class="form-row">
      <label for="card-element">
        Credit or debit card
      </label>
      <div class="form-control" id="card-element"></div>

      <div v-if="errorMsg" id="card-errors" role="alert">
        {{errorMsg}}
      </div>
    </div>
    <button class="btn btn-success" :disabled="!submitEnabled" @click="submit">Submit Payment</button>
  </div>
</template>

<script>
import { ref, inject } from "vue"
import {loadStripe } from '@stripe/stripe-js';

export default {
  emits: ['submit', 'submitting', 'done-submitting'],
  props: { submitEnabled: Boolean },
  setup(props, { emit }) {
    const errorMsg = ref('')
    let stripe, card
    const workbench = inject('workbench')

    workbench.configItem('stripe_public_key')
    .then((public_key) => {
      loadStripe(public_key).
        then((resp) => {
          stripe = resp
          const elements = stripe.elements();
          const style = {
            base: {
              color: '#32325d',
              fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
              fontSmoothing: 'antialiased',
              fontSize: '16px',
              '::placeholder': {
                color: '#aab7c4'
              }
            },
            invalid: {
              color: '#fa755a',
              iconColor: '#fa755a'
            }
          };
          card = elements.create('card', {style: style})
          card.mount('#card-element');

          card.on('change', (event) => {
            if (event.error)
              errorMsg.value = event.error.message
            else
              errorMsg.value = ''
          })

        })
    })

    function submit() {

      if (!stripe)
        return

      emit('submitting')
      stripe.createToken(card).then((result) => {
        if (result.error) {
          errorMsg.value = result.error.message
          emit('done-submitting')
        } else {
          emit('submit', result.token.id)
        }
      })
    }

    return {
      errorMsg,
      submit
    }
  }
}
</script>

<style scoped>
.btn {
  margin-top: 1em;
}
</style>
